'use strict';

const jQuery = require('jquery');

const Container = require('./../../../core/container');

const zone = require('./../../../services/structure/zone');
const Translator = require('./../../../core/translator');
const FormBuilder = require('./../../../services/form');
const Notifier = require('./../../../services/notifier');
const Loader = require('./../../../services/loader');
const Help = require('./../../../services/help');

const UserPrefRepo = require('./../../content/repository/UserPreferenceRepository');

const onSubmit = function(data) {
  zone.hidePanels(Container.get('$smallPanel'));

  if (data.google) {
    UserPrefRepo.save('google-analytics', {'code': data.google});
  } else {
    UserPrefRepo.del('google-analytics');
  }

  if (data.gtm) {
    UserPrefRepo.save('gtm-analytics', {'code': data.gtm});
  } else {
    UserPrefRepo.del('gtm-analytics');
  }

  Notifier.success(Translator.translate('parameters_saved'));
};

const onValidate = function(data, form) {
  if (data.gtm && !data.gtm.match('^GTM\-[a-zA-Z0-9]+$')) {
    form.addError('gtm', Translator.translate('code_format_error'));
  }
};

module.exports.onClick = function() {
  let $container = jQuery('<div></div>');

  let $layer = zone.addLayer(Translator.translate('analytics'), $container, {
    'extraTitle': Help.createLink('analytics'),
  });

  Loader.start($layer);

  UserPrefRepo.find('gtm-analytics').done((gtmData) => {
    UserPrefRepo.find('google-analytics').done((googleData) => {
      let form = FormBuilder.getForm({
        'elements': {
          'google': {
            'type': 'text',
            'label': 'Google',
            'value': typeof googleData === 'object' ? googleData.code : '',
            'question': 'https://ga-dev-tools.appspot.com/account-explorer',
          },
          'gtm': {
            'type': 'text',
            'label': 'Google Tag Manager',
            'value': typeof gtmData === 'object' ? gtmData.code : '',
            'placeholder': 'GTM-XXXX',
            'question': 'https://developers.google.com/tag-manager/devguide',
          },
        },
        'form': {
          'submit_class': 'd-none',
        },
      });

      $container.append(form.render());

      Loader.stop($layer);

      form.on('validate', onValidate);
      form.on('submit', onSubmit);

      zone.setFooter($layer, zone.createSubmitButtons({
        onSubmitClick: form.submit.bind(form),
      }));
    });
  });
};
